<template> 
  <div class="portada-xv" ref="rootRef" aria-label="Portada de XV">

    <!-- IMAGEN -->
    <div class="imagen-xv-wrapper" ref="fotoRef">
      <img src="@/assets/2E0A1293_max.webp" class="imagen-xv" alt="Foto protagonista" />
    </div>

    <br /> <br /> <br /> <br />

    <!-- TEXTO -->
    <section class="texto-xv">

      <p class="frase-bendicion" ref="bendicionRef">
        Con la bendición de Dios <br />
        y de mis padres
      </p>

      <h1 class="nombre-protagonista" ref="nombre1Ref">
        Sergio<br> Martínez Pascasio
      </h1>

      <!-- 💎 AMPERSAND -->
      <img
        src="@/assets/ampersand.png"
        class="ampersand"
        alt="&"
        ref="ampRef"
      />

      <h1 class="nombre-protagonista" ref="nombre2Ref">
       Edna Lorena <br>Flores Méndez
      </h1>

      <div
        class="separador-elegante"
        ref="separadorRef"
      ></div>

      <p class="parrafo-presentacion" ref="parrafoRef">
       Hoy queda en el recuerdo mi niñez, pero hoy renazco para vivir el momento más feliz de mi vida: mi adolescencia. quisiera que estés junto a mi para que compartamos mis
      </p>

      <p class="salmo-ref" ref="salmoRef">
        Mis 15 años
      </p>

    </section>
  </div>
</template>

<script>
import { onMounted, ref, nextTick } from 'vue'
import gsap from 'gsap'

export default {
  name: 'PortadaArley',

  setup() {

    const rootRef = ref(null)

    const fotoRef = ref(null)
    const bendicionRef = ref(null)
    const nombre1Ref = ref(null)
    const nombre2Ref = ref(null)
    const ampRef = ref(null)
    const separadorRef = ref(null)
    const parrafoRef = ref(null)
    const salmoRef = ref(null)

    const animateOnViewport = (element, animation) => {

      if (!element) return

      const observer = new IntersectionObserver(
        ([entry]) => {

          if (entry.isIntersecting) {

            animation()

            observer.unobserve(element)
          }

        },
        {
          threshold: 0.35,
          rootMargin: '0px 0px -80px 0px'
        }
      )

      observer.observe(element)
    }

    onMounted(async () => {

      await nextTick()

      // 🔥 ESTADOS INICIALES
      gsap.set(fotoRef.value, {
        opacity: 0,
        scale: 0.9,
        y: 80,
        filter: 'blur(10px)'
      })

      gsap.set([
        bendicionRef.value,
        nombre1Ref.value,
        nombre2Ref.value,
        separadorRef.value,
        parrafoRef.value,
        salmoRef.value
      ], {
        opacity: 0,
        y: 45
      })

      gsap.set(ampRef.value, {
        opacity: 0,
        scale: 0,
        rotate: -25
      })

      // 🔥 FOTO
      animateOnViewport(fotoRef.value, () => {

        gsap.to(fotoRef.value, {
          opacity: 1,
          scale: 1,
          y: 0,
          filter: 'blur(0px)',
          duration: 1.4,
          ease: 'power3.out'
        })

      })

      // 🔥 TEXTO 1
      animateOnViewport(bendicionRef.value, () => {

        gsap.to(bendicionRef.value, {
          opacity: 1,
          y: 0,
          duration: 1,
          ease: 'power2.out'
        })

      })

      // 🔥 NOMBRE 1
      animateOnViewport(nombre1Ref.value, () => {

        gsap.fromTo(
          nombre1Ref.value,
          {
            opacity: 0,
            y: 80,
            letterSpacing: '12px'
          },
          {
            opacity: 1,
            y: 0,
            letterSpacing: '0px',
            duration: 1.2,
            ease: 'power3.out'
          }
        )

      })

      // 🔥 AMPERSAND TIPO SELLO
      animateOnViewport(ampRef.value, () => {

        const tl = gsap.timeline()

        tl.to(ampRef.value, {
          opacity: 1,
          scale: 1.4,
          rotate: 8,
          duration: 0.45,
          ease: 'power4.out'
        })

        .to(ampRef.value, {
          scale: 0.9,
          rotate: -4,
          duration: 0.22,
          ease: 'power1.inOut'
        })

        .to(ampRef.value, {
          scale: 1,
          rotate: 0,
          duration: 0.28,
          ease: 'back.out(4)'
        })

      })

      // 🔥 NOMBRE 2
      animateOnViewport(nombre2Ref.value, () => {

        gsap.fromTo(
          nombre2Ref.value,
          {
            opacity: 0,
            y: 80,
            letterSpacing: '12px'
          },
          {
            opacity: 1,
            y: 0,
            letterSpacing: '0px',
            duration: 1.2,
            ease: 'power3.out'
          }
        )

      })

      // 🔥 SEPARADOR
      animateOnViewport(separadorRef.value, () => {

        gsap.fromTo(
          separadorRef.value,
          {
            width: '0%',
            opacity: 0
          },
          {
            width: '100%',
            opacity: 1,
            duration: 1.2,
            ease: 'power2.out'
          }
        )

      })

      // 🔥 PÁRRAFO
      animateOnViewport(parrafoRef.value, () => {

        gsap.to(parrafoRef.value, {
          opacity: 1,
          y: 0,
          duration: 1,
          ease: 'power2.out'
        })

      })

      // 🔥 SALMO
      animateOnViewport(salmoRef.value, () => {

        gsap.fromTo(
          salmoRef.value,
          {
            opacity: 0,
            scale: 0.6,
            y: 40
          },
          {
            opacity: 1,
            scale: 1,
            y: 0,
            duration: 1,
            ease: 'back.out(2)'
          }
        )

      })

    })

    return {
      rootRef,
      fotoRef,
      bendicionRef,
      nombre1Ref,
      nombre2Ref,
      ampRef,
      separadorRef,
      parrafoRef,
      salmoRef
    }
  }
}
</script><style scoped>

/* =========================
   CONTENEDOR PRINCIPAL
========================= */
.portada-xv{
  position: relative;
  width: 100%;
  min-height: 100vh;
  overflow: hidden;

  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 120px 16px 56px;

  /* 🔥 Imagen de fondo */
  background-image: url('@/assets/descarga (17).jpeg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  z-index: 1;
  isolation: isolate;
}

/* =========================
   FLORES
========================= */
.flor{
  position:absolute;
  width:min(44vw,240px);
  z-index:0;
  pointer-events:none;
}

.flor-1{ top:-10px; left:-110px; }
.flor-2{ top:20px; right:-80px; transform:rotate(-80deg); }
.flor-3{ bottom:-190px; left:-120px; }

.flor-4{ top:80px; left:0; transform:translateX(-50%) rotate(-12deg); }
.flor-5{ bottom:20px; right:0; transform:translateX(-50%) rotate(-12deg); }
.flor-6{ top:420px; right:-150px; transform:translateX(-50%) rotate(-12deg); }

/* =========================
   IMAGEN (🔥 FIX REAL)
========================= */
.imagen-xv-wrapper{
  position:absolute; /* 🔥 CAMBIO CLAVE */
  top:40px;
  margin-bottom: 20px;
  left:50%;
  transform:translateX(-50%);

  z-index:5;

  width:min(92vw,360px);
  height:calc(min(92vw,360px)*1.5);

  border-radius:180px 180px 0 0;
  overflow:hidden;
  background:#fff;

  box-shadow:
    0 12px 40px rgba(0,0,0,.18),
    0 2px 8px rgba(0,0,0,.06);
}

.imagen-xv{
  width:100%;
  height:100%;
  object-fit:cover;
}

/* =========================
   TEXTO
========================= */
.texto-xv{
  position:relative;
  z-index:6;
  margin-top:380px; /* 🔥 espacio para que no choque con la imagen */
  max-width:620px;
  text-align:center;
}

/* =========================
   AMPERSAND
========================= */
.ampersand{
  display:block;
  margin:8px auto;  filter: brightness(0); /* 🔥 negro */

  width:100px;
  z-index:7;
  position:relative;
}

/* =========================
   RESTO
========================= */
.frase-bendicion{
  font-family:"Playfair Display", serif;
  font-size:clamp(18px,2.6vw,24px);
}

.nombre-protagonista{
  font-family:"hombre", cursive;
  font-size:30px;
  color:#010101;
}

.parrafo-presentacion{
  font-family:"quote", sans-serif;
  font-size:22px;  color:#010101;

}

.salmo-ref{
  text-align:center;
  font-size:33px;
  color:#010101;
  font-family:'hombre';
}

.separador-elegante{
  width:110px;
  height:2px;
  margin:12px auto;
  background:linear-gradient(90deg, transparent, #e7e4e5, transparent);
}

/* =========================
   BOLA
========================= */
.bola{
  position:absolute;
  width:120px;
  z-index:0;
}

</style>